import { renderRichText } from '@storyblok/js';
export default function ({ items, _editable, _uid, title, description, arrows, horizontalAlign }) {
  return {
    _editable,
    _uid,
    module: 'SFaq',
    title,
    description: renderRichText(description),
    items: items.map(item => ({
      title: item?.title,
      content: renderRichText(item?.content),
      id: item.id
    })),
    arrows,
    horizontalAlign
  };
}
